<template>
    <div :style="{position: 'relative', minHeight: calcMinHeight+'px'}">
        <div v-if="selectedSite && siteDetails" class="siteDetails"
             :style="{minHeight: calcMinHeight+'px'}">
            <transition name="fade" mode="out-in">
                <div :key="0" v-if="loadingSitetype" class="d-flex justify-center align-center" style="height: 30vh;">
                    <v-progress-circular :size="50" :width="3" :color="ada.pink"
                                         indeterminate
                    ></v-progress-circular>
                </div>
                <div :key="1" v-else>
                    <slot></slot>
                    <v-fade-transition>
                        <DeployButtonRow
                            v-if="role === 'display' || role === 'admin' || (role === 'native' && $attrs.subTab === 'native')"
                            @save="$emit('save')"
                            @deploy:preview="$emit('deploy:preview')"
                            @deploy:live="$emit('deploy:live')" v-bind="$attrs"></DeployButtonRow>
                    </v-fade-transition>
                </div>
            </transition>
        </div>
        <div v-else class="noSiteSelected" :style="{minHeight: calcMinHeight+'px'}">
            Bitte eine Seite zum Bearbeiten auswählen.
        </div>
    </div>
</template>

<script>

import DeployButtonRow from "../../../components/DeployButtonRow";
import ada from "../../../scss/ada_colors.scss";

export default {
    name: "TabWrapper",
    components: {DeployButtonRow},
    props: {
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    data: () => {
        return {
            ada
        }
    },
    mounted() {
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        selectedSite() {
            return this.vuexState.selectedSite;
        },
        siteDetails() {
            return this.vuexState.siteDetails;
        },
        activeTab() {
            return this.vuexState.activeTab;
        },
        calcMinHeight() {
            return this.vuexState.detailsContentMinHeight - 48; //-tabheaderHeight -paddingHeightTop&Bottom
        },
        loadingSitetype() {
            return this.vuexState.loadingSitetype;
        },
        role() {
            return this.$store.state.users.role;
        }
    },
    watch: {
        activeTab() {
            this.$emit('change', this.activeTab);
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .layout.row {
    margin: 0 !important;
}

.siteDetails {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
}
</style>